import { useQuery } from "@tanstack/react-query";
import { apiClient, ApiError } from "@/lib/apiClient";
import { queryKeys } from "@/lib/query";
import { UserType } from "@/types/domain";
import type { CounterpartyReference } from "@/types/api/tokenOperation";
import { useCurrentUser } from "./useCurrentUser";

export function useMyReferenceNumber() {
  const { data: user } = useCurrentUser();
  const enabled =
    user?.userType === UserType.Employee ||
    user?.userType === UserType.Financier;

  return useQuery({
    queryKey: queryKeys.tokenOperations.myReferenceNumber(),
    queryFn: () =>
      apiClient.getData<CounterpartyReference>(
        "/token-operations/my-reference-number"
      ),
    enabled,
    retry: (failureCount, error) =>
      !(error instanceof ApiError && error.statusCode === 401) && failureCount < 1,
    staleTime: 5 * 60 * 1000,
  });
}
